import moment from 'moment'
import momentTimezone from 'moment-timezone'

// Función para obtener fecha tipo string en formato YYYY-MM-DD - uso general: requests a Argentia
export const formatDateOnlyString = date => {
  return date ? moment.parseZone(date).format('YYYY-MM-DD') : undefined
}

// Función para obtener objeto moment con la fecha en formato YYYY-MM-DD : 00.00.00 en hora local - uso general: get from Argentia evitando el cambio horario
export const formatDateOnlyMoment = date => {
  return date ? moment(moment.parseZone(date).startOf('day').format('YYYY-MM-DD')) : undefined
}

// Función para obtener fecha tipo Date en formato YYYY-MM-DD : 00.00.00 en hora local - uso general: get from Argentia evitando el cambio horario
export const formatDateOnlyDate = date => {
  return date
    ? moment(moment.parseZone(date).startOf('day').format('YYYY-MM-DD')).toDate()
    : undefined
}

// Función para obtener fecha tipo string en formato dd-MM-yyyy HH:mm - uso general: commentList
export const formatDateOnlyStringWithTime = date => {
  const offset = getMadridOffsetInHours(date) // Será 1 o 2 dependiendo de si es horario de verano o no
  return date ? moment.utc(date).add(offset, 'hour').local().format('DD-MM-YYYY HH:mm') : undefined
}
// se le suma 1 hora porque la fecha de España esta una hora atrasada respecto de la del servidor y se guarda como UTC y no lo es

const getMadridOffsetInHours = date => {
  // Crea un momento en la zona horaria de Madrid
  const madridMoment = moment.tz(date, 'Europe/Madrid')
  // Obtiene el offset en minutos y lo convierte a horas
  return madridMoment.utcOffset() / 60
}

// Función para obtener fecha tipo string en formato dd-MM-yyyy - uso general: formatear fechas de servidor y mostrarlas en la fecha/hora local
export const formatServerDate = date => {
  const offset = getMadridOffsetInHours(date) // Será 1 o 2 dependiendo de si es horario de verano o no
  return date ? moment.utc(date).add(offset, 'hour').local().format('DD-MM-YYYY') : undefined
}

// Función para obtener fecha tipo string en formato dd-MM-yyyy - uso general: formatear fechas de servidor y mostrarlas en la fecha/hora Española
export const formatServerDateSpain = date => {
  const offset = getMadridOffsetInHours(date) // Será 1 o 2 dependiendo de si es horario de verano o no
  return date ? moment.utc(date).add(offset, 'hour').format('DD-MM-YYYY') : undefined
}

// Función recursiva para convertir Date a string DD/MM/YYYY
export function convertDatesToDDMMYYYY(obj: any): any {
  if (obj === null || obj === undefined || typeof obj === 'string') return obj
  if (obj instanceof Date) return moment(obj).format('YYYY/MM/DD')
  if (Array.isArray(obj)) return obj.map(convertDatesToDDMMYYYY)
  if (typeof obj === 'object') {
    const newObj: any = {}
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        newObj[key] = convertDatesToDDMMYYYY(obj[key])
      }
    }
    return newObj
  }
  return obj
}
